import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { find } from 'lodash-es'
import ActionTypes from '@constants/action_types.js'

const stackViewsAdapter = createEntityAdapter()

// create initial state for the views slice and include a view to act as the default view
const initialState = stackViewsAdapter.getInitialState({
  ids: [],
  entities: {},
})

const slice = createSlice({
  name: 'stackViews',
  initialState,
  extraReducers: builder => {
    builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => {
      const { payload } = action
      if (payload.hasOwnProperty('stack_views')) {
        stackViewsAdapter.upsertMany(state, payload.stack_views)
      }
    })
  },
})

// Selectors

export const stackViewsSelectors = stackViewsAdapter.getSelectors(state => state.data.stackViews)

export const getStackView = (state, props) => {
  const { stackViewId } = props
  const allEntities = stackViewsSelectors.selectAll(state)
  return find(allEntities, entity => {
    const result = entity.id.toString() === stackViewId.toString()
    return result
  })
}

export default slice.reducer
